export function getIsNowOverAYear(checkDateStr: string): boolean {
  const checkDate = new Date(checkDateStr);

  // 1년 지난 경우
  if (checkDate.getTime() + 1000 * 60 * 60 * 24 * 365 < new Date().getTime()) {
    return true;
  }
  return false;
}
